export default "__VITE_ASSET__599de52b__"